import { useMemo } from 'react';
import { useRealplayStore } from 'features/realplays/RealPlays.store';
import Organization from 'infrastructure/Organization';

const AssignRealPlayDataHelper = () => {
  const isRep = Organization.isRep();
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  //values
  const { initiateRealPlay, realPlayAssignData, openModal : openModalRealPlay, closeModal : closeModalRealPlay } = useRealplayStore();

  const roleplay = useMemo(() => realPlayAssignData?.roleplay, [realPlayAssignData.roleplay]);
  const roleplay_uuid = useMemo(
    () => realPlayAssignData?.roleplay?.value ?? '',
    [realPlayAssignData?.roleplay]
  );
  const scenarios = useMemo(
    () => realPlayAssignData?.roleplay?.scenarios,
    [realPlayAssignData?.roleplay?.scenarios]
  );
  const personas_ai = useMemo(
    () => realPlayAssignData?.personas_ai,
    [realPlayAssignData?.personas_ai]
  );
  const attitudes = useMemo(() => realPlayAssignData?.attitudes, [realPlayAssignData?.attitudes]);
  const deadline = useMemo(() => realPlayAssignData?.deadline, [realPlayAssignData?.deadline]);
  const users = useMemo(() => realPlayAssignData?.users, [realPlayAssignData?.users]);
  const context = useMemo(() => realPlayAssignData?.context, [realPlayAssignData?.context]);

  //functions
  const {
    openModal,
    closeModal,
    setRolePlaySelect,
    setPersonasAI,
    setAttitudes,
    setDeadLine,
    updateScenarioSelection,
    updateAttitudesSelection,
    updatePersonaSelection,
    updateUsersSelection,
    updateIndustrySelector,
    updateTitleContext,
    updateCustomerSituation,
    reset,
  } = useRealplayStore();

  return {
    isRep,
    userInfo,
    initiateRealPlay,
    roleplay,
    roleplay_uuid,
    scenarios,
    personas_ai,
    attitudes,
    deadline,
    users,
    context,
    openModal,
    closeModal,
    setRolePlaySelect,
    setPersonasAI,
    setAttitudes,
    setDeadLine,
    updateScenarioSelection,
    updateAttitudesSelection,
    updatePersonaSelection,
    updateUsersSelection,
    updateIndustrySelector,
    updateTitleContext,
    updateCustomerSituation,
    reset,
    openModalRealPlay,
    closeModalRealPlay
  };
};

export default AssignRealPlayDataHelper;
